module.exports = __webpack_public_path__ + "static/media/DLF_F1.7f4d9b1c.txt";